








import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop, Watch} from 'vue-property-decorator';
import {
  NavBarTheme,
  navDarkTheme,
  navDefaultTheme,
  navLightTheme,
  SidebarTheme,
  sideDarkTheme,
  sideLightTheme
} from './NavBar/navbar-theme';

@Component({})
export default class SectionLayout extends Vue {

  @Prop({required: false, default: 'light'})
  navbarTheme!: 'dark' | 'light' | 'default';

  @Prop({required: false, default: 'light'})
  sidebarTheme!: 'dark' | 'light';

  @Prop({default: false})
  centered!: boolean;

  mounted() {
    this.enter('down');
  }

  enter(direction: string) {
    this.setNavBarTheme();
    this.onSidebarChange();
    this.$emit('animate', direction);
  }

  @Watch('navbarTheme')
  setNavBarTheme() {
    const root = document.documentElement;
    const theme: NavBarTheme = this.getNavBarTheme();
    root.style.setProperty('--ikone-logo', `var(--ikone-logo-${theme.logoColor})`);
    root.style.setProperty('--ikone-btn-menu', theme.backgroundColor);
    root.style.setProperty('--ikone-btn-menu-text', theme.textColor);
  }

  @Watch('sidebarTheme')
  onSidebarChange() {
    const root = document.documentElement;
    const theme: SidebarTheme = this.getSidebarTheme();
    root.style.setProperty('--ikone-side-menu-active', theme.sideMenuActive);
    root.style.setProperty('--ikone-side-menu-inactive', theme.sideMenuInactive);
  }

  private getSidebarTheme(): SidebarTheme {
    switch (this.sidebarTheme) {
      case 'dark':
        return sideDarkTheme;
      case 'light':
        return sideLightTheme
    }
  }

  private getNavBarTheme(): NavBarTheme {
    switch (this.navbarTheme) {
      case 'dark':
        return navDarkTheme;
      case 'light':
        return navLightTheme;
      case 'default':
        return navDefaultTheme;
    }
  }

}

